export const PO_NUMBER_POSITION = 'TR[2]/TD[2]'
export const ITEM_NO_INDEX = 0
export const MATERIAL_INDEX = 1
export const DESCRIPTION_INDEX = 2
export const DELIVERY_DATE_INDEX = 3
export const MODE_INDEX = 4
export const ACCEPTNACE_DATE = 5